<template>
    <v-app-bar
        app
        clipped-left
        color="primary"
        dark
    >
        <v-app-bar-nav-icon
            v-if="
                $vuetify.breakpoint.lgAndUp ||
                $store.get('auth/role') !== 'user'
            "
            @click="drawer = !drawer"
        ></v-app-bar-nav-icon>

        <app-bar-logo></app-bar-logo>

        <v-toolbar-title class="ml-0 ml-lg-6">
            {{ $store.get('ui/title') }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-progress-circular
            v-if="$store.get('loader/loading', 'appbar')"
            color="white"
            indeterminate
            class="mr-4"
        ></v-progress-circular>

        <maintenance-toolbar-indicator></maintenance-toolbar-indicator>

        <span class="d-none d-sm-block mr-4">
            {{ $store.get('auth/name') }}
        </span>

        <v-menu
            left
            offset-y
            nudge-bottom="12"
        >
            <template #activator="{ on }">
                <v-avatar
                    v-on="on"
                    v-ripple
                    color="avatar"
                >
                    <v-img
                        v-if="profileImage"
                        :src="profileImage"
                    ></v-img>
                    <v-icon
                        v-else
                        color="primary"
                    >
                        mdi-account
                    </v-icon>
                </v-avatar>
            </template>

            <v-list
                width="250"
                dense
            >
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $store.get('auth/name') }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ $store.get('auth/university') }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item :to="{ name: 'settings' }">
                    <v-list-item-icon>
                        <v-icon>mdi-cog</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Pengaturan</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                    link
                    @click="logout"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Keluar</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
import { get, sync } from 'vuex-pathify'
import AppBarLogo from '@/components/AppBarLogo'
import MaintenanceToolbarIndicator from './maintenance/MaintenanceToolbarIndicator.vue'

export default {
    components: {
        AppBarLogo,
        MaintenanceToolbarIndicator,
    },

    computed: {
        drawer: sync('ui/drawer'),

        profileImage: get('auth/image'),
    },

    methods: {
        logout() {
            window._paq.push(['resetUserId'])
            window._paq.push(['trackEvent', 'Akun', 'Keluar'])
            this.$api.delete('auth', { loader: 'appbar' }).then(() => {
                this.$router.push({ name: 'home' })

                this.$store.dispatch('auth/unsetData')
            })
        },
    },

    watch: {
        $route(to) {
            this.$store.set('ui/title', to.meta.title)
        },
    },

    created() {
        this.$store.set('ui/title', this.$route.meta.title)
    },
}
</script>
